import { readImageRecord, updateImageRecord, deleteImageRecord } from "./imageStorage";

async function dbUploadImage(type, images) {
  return updateImageRecord(type, record => ({ ...record, images: [...(record?.images || []), ...images] }));
}
async function dbLoadImages(type) {
  return (await readImageRecord(type))?.images || [];
}
const dbDeleteAllImages = deleteImageRecord;
function dbDeleteImage(type, index) {
  return updateImageRecord(type, record => {
    if (!record?.images?.[index]) throw new Error("Image not found for deletion");
    return { ...record, images: record.images.filter((_, i) => i !== index) };
  });
}
function editImage(type, index, field, value) {
  return updateImageRecord(type, record => {
    if (!record?.images?.[index]) throw new Error("Image not found for editing");
    return { ...record, images: record.images.map((image, i) => i === index ? { ...image, [field]: value } : image) };
  });
}
const dbEditImageText = (type, index, value) => editImage(type, index, "text", value);
const saveColorAtIndex = (type, index, value) => editImage(type, index, "color", value);
const editImageCount = (type, index, value) => editImage(type, index, "count", value);
const dbADDImageSrcRm = (type, index, value) => editImage(type, index, "srcRm", value);
const dbADDImageBg = (type, index, value) => editImage(type, index, "Bg", value);
const saveDocumentTypeAtIndex = (type, index, value) => editImage(type, index, "documentType", value);

export {
  dbADDImageBg,
  dbADDImageSrcRm,
  saveColorAtIndex,
  editImageCount,
  dbEditImageText,
  dbDeleteImage,
  dbDeleteAllImages,
  dbUploadImage,
  dbLoadImages,
  saveDocumentTypeAtIndex
};
